export default "__VITE_ASSET__BusmVtc$__"